import { ValidDurationFrom } from "../../../types/unitItem";
import { useUnitItemType } from "../../../types/hooks/useUnitItemType";

export function UnitItemValidDurationFrom({ from }: { from: ValidDurationFrom }) {
  const { toStringFromValidDurationFrom } = useUnitItemType();

  return <span style={{ textTransform: "lowercase" }}>{toStringFromValidDurationFrom(from)}</span>;
}
